
import { faro } from '@grafana/faro-web-sdk';

export async function sendErrorEvent( { companyId, message, personId, currentRoute, source, code } ) {
    const eventData = {
        companyId,
        message,
        personId,
        currentRoute,
        source,
        code
    };
    faro?.api?.pushEvent( 'ui-error', { ...eventData } );
}